"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var next_intl_1 = require("next-intl");
var react_1 = require("react");
var useSearchGamesDropdown = function (_a) {
    var games = _a.games, searchValue = _a.searchValue;
    var _b = (0, react_1.useState)(12), currentCount = _b[0], setCurrentCount = _b[1];
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var t = (0, next_intl_1.useTranslations)();
    var slicedGames = (0, react_1.useMemo)(function () { return __spreadArray([], games, true).slice(0, currentCount); }, [currentCount, games]);
    var handleLoadMoreButtonClick = (0, react_1.useCallback)(function () {
        if (currentCount) {
            setCurrentCount(function (prev) { return prev + prev; });
        }
    }, [currentCount]);
    (0, react_1.useEffect)(function () {
        if (searchValue === '' && currentCount !== 12) {
            setCurrentCount(12);
        }
    }, [searchValue, currentCount]);
    return {
        t: t,
        breakpoints: breakpoints,
        currentCount: currentCount,
        slicedGames: slicedGames,
        handleLoadMoreButtonClick: handleLoadMoreButtonClick,
    };
};
exports.default = useSearchGamesDropdown;
